export enum DeliveryGroupStatus {
  Wait = "WAIT",
  Work = "WORK",
  Reported = "REPORTED",
}
